import { IconButton, Stack, Tooltip } from '@mui/material';
import { DeleteIcon } from '@shared/custom-icons';
import { ReadMore } from '@mui/icons-material';
import { useCampaignTFunction } from '@retail/campaign/i18n';
import { Link } from 'react-router';

interface Props {
  deleteCampaign?: () => void;
  campaignHref: string;
}

export const CampaignActions = ({ deleteCampaign, campaignHref }: Props) => {
  const t = useCampaignTFunction();
  return (
    <Stack direction="row" flexWrap="nowrap">
      {deleteCampaign && (
        <Tooltip title={t('campaign.actions.deleteCampaign')}>
          <IconButton onClick={deleteCampaign}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title={t('campaign.actions.seeCampaign')}>
        <IconButton component={Link} to={campaignHref}>
          <ReadMore />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
